@import 'core';

@import '@fortawesome/fontawesome-pro/scss/fontawesome.scss';
@import '@fortawesome/fontawesome-pro/scss/brands.scss';
@import '@fortawesome/fontawesome-pro/scss/light.scss';
@import '@fortawesome/fontawesome-pro/scss/regular.scss';
@import '@fortawesome/fontawesome-pro/scss/solid.scss';

@import './components/ads-footer-link/ads-footer-link.scss';
@import './components/ads-footer-link-header/ads-footer-link-header.scss';
@import './components/ads-footer-link-section/ads-footer-link-section.scss';
@import './components/ads-footer-social-link/ads-footer-social-link.scss';
@import './components/ads-footer-legal-link/ads-footer-legal-link.scss';

/**
 * @prop --ads-footer-background-color: Background color
 * @prop --ads-footer-color: Text color
 * @prop --ads-footer-hr-border-color: Border color
 * @prop --ads-footer-legal-link-color: Legal link text color
 * @prop --ads-footer-legal-link-color-hover: Legal link text color when hovered
 * @prop --ads-footer-legal-link-color-visited: Legal link text color when visited
 * @prop --ads-footer-link-color: Link text color
 * @prop --ads-footer-link-color-hover: Link text color when hovered
 * @prop --ads-footer-link-color-visited: Link text color when visited
 * @prop --ads-footer-link-header-color: Header text color
 * @prop --ads-footer-link-header-color-hover: Header text color when hovered
 * @prop --ads-footer-link-header-color-visited: Header text color when visited
 * @prop --ads-footer-link-social-color: Social link text color
 * @prop --ads-footer-link-social-color-hover: Social link text color when hovered
 * @prop --ads-footer-link-social-color-visited: Social link text color when visited
 */

* {
  margin: 0;
  padding: 0;
  text-indent: 0;
}

:host {
  background-color: var(--ads-footer-background-color, $ads-footer-background-color);
  display: block;
  position: relative;
  width: 100%;
}

:host([theme='default']) {
  @include ads-vars-component-footer-default;
}

:host([theme='dark']) {
  @include ads-vars-component-footer-dark;
}

::slotted(*) {
  width: 100%;
}

.c-footer {
  color: var(--ads-footer-color, $ads-footer-color);
  font-size: 14px;
  font-family: var(--ads-font-family);
  line-height: 21px;
  padding-bottom: 32px;
  padding-top: 32px;

  ul {
    list-style: none;
    margin-bottom: 16px !important;
  }

  hr {
    border-color: var(--ads-footer-hr-border-color, $ads-footer-hr-border-color);
    margin-top: 16px;
  }

  &__slotted {
    display: flex;
    margin: 16px 0;
  }

  &__container {
    @include ads-container(true);
    @include ads-container-breakpoint-map(true);

    @include media-query(md-down) {
      @include ads-container-full-width(true);
    }
  }

  &__row {
    @include ads-grid-row(true);
  }

  &__column {
    @include ads-grid-column(true);
    @include ads-grid-responsive-column(true, 12, 12);

    &-6 {
      @include ads-grid-column(true);
      @include ads-grid-responsive-column(true, 12, 12);

      @include media-query(md-up) {
        @include ads-grid-responsive-column(true, 6, 12);
      }
    }
  }

  &__social-link-list {
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    gap: 27px;
  }

  &__legal-link-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}
